import React, {useCallback, useMemo, useState} from 'react'
import PropTypes from 'prop-types'
import {
    AccordionButton,
    AccordionItem,
    AccordionPanel,
    Text,
    useAccordionItemState,
    useDisclosure
} from '@chakra-ui/react'
import {MinusIcon, PlusIcon} from '../../../components/icons'
import ProductSetTile from '../../../components/product-set-tile'
import ProductSetModal from './product-set-modal'
import {trackPsdpClickProductTile} from '../../../tracking/analytics'

const AccordionIcon = () => {
    const {isOpen} = useAccordionItemState()

    const Icon = isOpen ? MinusIcon : PlusIcon

    return <Icon boxSize={4} />
}

const CustomizablePsdpCustomizationProducts = ({
    label,
    labelPrefix,
    products,
    tileCheckboxEvent
}) => {
    const [modalProduct, setModalProduct] = useState(null)
    const {isOpen, onClose} = useDisclosure({
        isOpen: modalProduct != null,
        onClose: () => setModalProduct(null)
    })

    // use updated product from products in case it was updated
    const updatedModalProduct = useMemo(() => {
        if (!modalProduct) {
            return null
        }
        return products.find((product) => product.setProductId === modalProduct.setProductId)
    }, [modalProduct, products])

    const onTileClick = useCallback((product) => {
        setModalProduct(product)
        trackPsdpClickProductTile(product)
    }, [])

    return (
        <>
            <ProductSetModal
                isOpen={isOpen}
                isSelectable
                onClose={onClose}
                product={updatedModalProduct}
            />
            <AccordionItem display="flex" flexDirection="column" gap={6}>
                <AccordionButton>
                    {labelPrefix && (
                        <Text
                            alignSelf="flex-start"
                            marginInlineEnd={2}
                            color="stokkeGray.dark"
                            textStyle="Semi Bold Small"
                        >
                            {labelPrefix}
                        </Text>
                    )}
                    <Text flex="1" textAlign="left" textStyle="Regular XLarge">
                        {label}
                    </Text>
                    <AccordionIcon />
                </AccordionButton>

                <AccordionPanel display="flex" flexDirection="column" gap={2}>
                    {products.map((product, index) => (
                        <ProductSetTile
                            key={index}
                            product={product}
                            variant="selectable"
                            onClick={onTileClick}
                            tileCheckboxEvent={tileCheckboxEvent}
                        />
                    ))}
                </AccordionPanel>
            </AccordionItem>
        </>
    )
}

CustomizablePsdpCustomizationProducts.propTypes = {
    label: PropTypes.string,
    labelPrefix: PropTypes.string,
    products: PropTypes.array,
    tileCheckboxEvent: PropTypes.string
}

export default CustomizablePsdpCustomizationProducts
